import { ArrowUpRight, Project, Target } from '@griply/assets';
import { GoalType } from '@griply/types';
import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { projectsHelpLink } from 'shared/constants';
import {
  useOpenCreateGoalDialog,
  useOpenCreateProjectDialog,
} from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { ID } from 'shared/types/id';

export type LifeAreaRoadmapAddMenuProps = {
  parentIds: ID[];
  lifeAreaId?: ID | null;
  onClose?: () => void;
};

export const LifeAreaRoadmapAddMenu: React.FC<LifeAreaRoadmapAddMenuProps> = ({
  parentIds,
  lifeAreaId,
  onClose,
}) => {
  const { t } = useTranslation();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();
  const { allowed: createProjectAllowed } = useCreateUnlimitedGoalsAllowed(
    GoalType.Project,
  );
  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const openCreateProjectDialog = useOpenCreateProjectDialog();

  const close = () => onClose?.();

  const onCreateGoal = () => {
    close();
    if (!createGoalAllowed) {
      openPremiumDialog();
      return;
    }
    openCreateGoalDialog({ parentIds, lifeAreaId });
  };

  const onCreateProject = () => {
    close();
    if (!createProjectAllowed) {
      openPremiumDialog();
      return;
    }
    openCreateProjectDialog({ parentIds, lifeAreaId });
  };

  const onLearnMore = () => {
    close();
    window.open(projectsHelpLink, '_blank', 'noreferrer');
  };

  return (
    <>
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onCreateGoal}
            isPremium={!createGoalAllowed}
            start={<Icon icon={Target} />}
            subtitle={t('goals.add-menu.goal.subtitle')}
          >
            {t('goals.add-menu.goal.title')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onCreateProject}
            isPremium={!createProjectAllowed}
            start={<Icon icon={Project} />}
            subtitle={t('goals.add-menu.project.subtitle')}
          >
            {t('goals.add-menu.project.title')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
      <PopupMenuList>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onLearnMore}
            start={<Icon icon={ArrowUpRight} />}
            subtitle={t('goals.add-menu.learn-more.subtitle')}
          >
            {t('goals.add-menu.learn-more.title')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
    </>
  );
};
